import { useEffect, useState } from "react";
import api from "@/lib/api";
import MarketingShell from "@/components/MarketingShell";

export default function LegalPage({ section }) {
  // section: "privacy" or "terms"
  const [content, setContent] = useState(null);
  useEffect(() => { api.get("/site-content").then(({ data }) => setContent(data)); }, []);
  const doc = content?.[section];

  return (
    <MarketingShell content={content}>
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 pb-24 animate-fade-up">
        <span className="label-eyebrow text-mr-accent">Legal</span>
        <h1 className="font-display font-bold tracking-tight text-4xl sm:text-5xl text-mr-primary mt-3">{doc?.title}</h1>
        {doc?.updated_at && <p className="text-mr-secondary mt-3">Last updated · {doc.updated_at}</p>}

        <div className="mt-10 bg-white border border-mr rounded-2xl p-8 lg:p-10">
          <div className="space-y-4 text-mr-primary text-[15px] leading-relaxed whitespace-pre-line">
            {doc?.body}
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
